module.exports = __webpack_public_path__ + "img/partner5.0049ff1a.png";